document.addEventListener('DOMContentLoaded', function() {
    const bookingModal = document.getElementById('bookingModal');

    if (bookingModal) {
        const bookingContainers = document.querySelectorAll('.booking');

        bookingContainers.forEach(bookingContainer => {
            bookingContainer.addEventListener('click', function(event) {
                const bookingItem = event.target.closest('.booking-item');

                if (bookingItem) {
                    const dateElement = bookingItem.querySelector('.booking-date');
                    const timeElement = bookingItem.querySelector('.booking-time');
                    const headlineElement = bookingItem.querySelector('.form-headline');
                    const formIndex = bookingItem.dataset.formIndex;

                    if (dateElement && timeElement) {
                        const date = dateElement.textContent.trim();
                        const time = timeElement.textContent.trim();
                        const headline = headlineElement?.textContent.trim();

                        // Update modal content
                        const modalTitle = bookingModal.querySelector('.modal-title');
                        const modalSubtitle = bookingModal.querySelector('.modal-subtitle');


                        if (modalTitle) {
                            modalTitle.textContent = headline;
                        }
                        if (modalSubtitle) {
                            modalSubtitle.textContent = `${date}, ${time}`;
                        }

                        // Hide all forms first
                        const allForms = bookingModal.querySelectorAll('.ninja-form-wrapper');
                        allForms.forEach(form => {
                            form.style.display = 'none';
                        });

                        // Show the selected form
                        const selectedForm = document.getElementById(formIndex);
                        if (selectedForm) {
                            selectedForm.style.display = 'block';

                            const formId = selectedForm.querySelector('.nf-form-cont').id.replace('nf-form-', '').replace('-cont', '');
                            const formTitleInput = selectedForm.querySelector('.course_title input');
                            const formTimeInput = selectedForm.querySelector('.course_time input');

                            if (formTitleInput && formTimeInput) {
                                // Set DOM Values
                                formTitleInput.value = headline;
                                formTimeInput.value = `${date}, ${time}`;

                                // Events für DOM Updates
                                formTitleInput.dispatchEvent(new Event('change', { bubbles: true }));
                                formTimeInput.dispatchEvent(new Event('change', { bubbles: true }));

                               // Update Ninja Forms Modal
                                if (window.nfForms && window.nfForms[formId] && window.nfForms[formId].formContentData) {
                                    try {
                                        // Field IDs aus den Input-Elementen extrahieren
                                        const titleFieldId = formTitleInput.id.replace('nf-field-', '');
                                        const timeFieldId = formTimeInput.id.replace('nf-field-', '');

                                        // Model Fields updaten
                                        window.nfForms[formId].formContentData.fields.forEach(field => {
                                            if (field.id == titleFieldId) {
                                                field.value = headline;
                                            }
                                            if (field.id == timeFieldId) {
                                                field.value = `${date}, ${time}`;
                                            }
                                        });
                                    } catch(e) {
                                        console.log('Ninja Forms update failed, setting values directly');
                                        // Direktes Update der Input-Werte als Fallback
                                        formTitleInput.value = headline;
                                        formTimeInput.value = `${date}, ${time}`;
                                    }
                                } else {
                                    // Wenn nfForms nicht verfügbar ist
                                    formTitleInput.value = headline;
                                    formTimeInput.value = `${date}, ${time}`;
                                }
                            }

                            // Equipment fields toggle handler
                            const equipmentContainer = selectedForm.querySelector('.equipment-check');
                            if (equipmentContainer) {
                                const equipmentRadios = equipmentContainer.querySelectorAll('input[type="radio"]');
                                const equipmentItems = selectedForm.querySelectorAll('.equipment-item');

                                equipmentRadios.forEach(radio => {
                                    radio.addEventListener('change', function() {
                                        // Check if this is the "JA" radio button
                                        const isYes = this.id.endsWith('-0'); // First radio button is usually "JA"
                                        const container = equipmentItems[0]?.closest('.nf-field-container');

                                        if (container) {
                                            equipmentItems.forEach(item => {
                                                const fieldContainer = item.closest('.nf-field-container');
                                                if (fieldContainer) {
                                                    fieldContainer.style.display = isYes ? 'none' : 'block';
                                                }
                                            });
                                        }
                                    });
                                });
                            }
                        } else {
                            console.error('Form not found for index:', formIndex);
                        }
                    }
                }
            });
        });

         // Apply styling after modal is shown
         bookingModal.addEventListener('shown.bs.modal', function() {
            const submitButtons = bookingModal.querySelectorAll('input[type="submit"]');
            const formTitle = bookingModal.querySelector('.nf-form-title');

            if (formTitle) {
                formTitle.remove();
            }

            const checkBoxes = bookingModal.querySelectorAll('.checkbox-wrap');
            checkBoxes.forEach( checkBox => {
                if (checkBox) {
                    const checkBoxLabel = checkBox.querySelector('.nf-field-label');
                    const checkBoxDescription = checkBox.querySelector('.nf-field-description');

                    if (checkBoxLabel && checkBoxDescription) {
                        checkBoxLabel.classList.add('w-auto', 'align-items-start');
                        checkBoxDescription.classList.add('me-0');
                    }
                }
            } );


            if (submitButtons) {
                submitButtons.forEach(submitButton => {
                    Object.assign(submitButton.style, {
                        fontSize: '16px',
                        lineHeight: '24px',
                        padding: '12px 24px',
                        whiteSpace: 'nowrap',
                        color: '#212529',
                        border: 'none',
                        backgroundColor: '#b9e9eb',
                        cursor: 'pointer'
                    });

                    submitButton.addEventListener('mouseenter', function() {
                        this.style.backgroundColor = 'turquoise';
                    });

                    submitButton.addEventListener('mouseleave', function() {
                        this.style.backgroundColor = '#b9e9eb';
                    });
                });
            }
        });

        // Handle modal close
        bookingModal.addEventListener('hidden.bs.modal', function () {
            window.location.reload();
        });
    }
});